
const priceInquiryRoutes = [
  {
    path: '/priceInquiry/home',
    name: 'priceInquiry',
    component: () => import(/* webpackChunkName: "priceInquiry" */ '@/views/priceInquiry/index.vue'),
    meta: {
      title: "我的询价",
      keepAlive: true,
    },
  },
  {
    path: '/quotation/list',
    name: 'quotation',
    component: () => import(/* webpackChunkName: "quotation" */ '@/views/priceInquiry/quotation/index.vue'),
    meta: {
      title: "报价信息",
      keepAlive: true,
    },
  },
  {
    path: '/quotation/detail',
    name: 'quotationDetail',
    component: () => import(/* webpackChunkName: "quotationDetail" */ '@/views/priceInquiry/quotation/detail/index.vue'),
    meta: {
      title: "报价信息",
      keepAlive: true,
    },
  },
  {
    path: '/priceInquiry/edit',
    name: 'priceInquiryEdit',
    component: () => import(/* webpackChunkName: "priceInquiryEdit" */ '@/views/priceInquiry/edit/index.vue'),
    meta: {
      title: "我的询价",
      keepAlive: true,
    },
  },
  {
    path: '/priceInquiry/detail',
    name: 'inquiryDetailInfo',
    component: () => import(/* webpackChunkName: "inquiryDetailInfo" */ '@/views/priceInquiry/detail/index.vue'),
    meta: {
      title: "我的询价",
      keepAlive: true,
    },
  }
];

export default priceInquiryRoutes;
